import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { loadExternalScript } from '@Shared/Common';
import { cookie } from '@Shared/Common';
import { parseJwtToken } from '../_util';
export var GoogleConnectSdk =
/*#__PURE__*/
function () {
  // https://developers.google.com/identity/gsi/web/guides/migration
  // https://developers.google.com/identity/gsi/web/reference/js-reference
  // https://stackoverflow.com/questions/72612704/how-to-get-oauth-token-after-google-one-tap-sign-in-jwt-token-response-of-one-t
  function GoogleConnectSdk() {
    _classCallCheck(this, GoogleConnectSdk);

    this.isInitialized = false;
  }

  _createClass(GoogleConnectSdk, [{
    key: "signIn",
    value: function signIn(googleClientId) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var _this = _this2; // This handler is called when the Google script loads

        var callbackWithInit = function callbackWithInit() {
          if (window.google && window.google.accounts) {
            // Here is an event handler for the sign-on attempt
            var handleCredentialResponse = function handleCredentialResponse(loginInfo) {
              // The call worked, decode the response info
              var decodedLoginInfo = parseJwtToken(loginInfo.credential); // Store the JWT token into a cookie for My Account or other use, later on

              cookie.setCookie('gmi.googlecredential', loginInfo.credential, 365, true); // Return to our caller

              resolve({
                idToken: loginInfo.credential,
                accessToken: '',
                email: decodedLoginInfo.email
              });
            }; // Kick off the Google single sign-on code, give it our callback function


            _this._initializeGoogleAccount(googleClientId, handleCredentialResponse); // Now provide the user with the One Tap prompt


            _this._promptGoogleAccount(googleClientId);
          } else {
            reject('Error loading Google SDK');
          }
        }; // Load the Google script


        var attributes = [{
          name: 'async',
          value: 'async'
        }];
        loadExternalScript('https://accounts.google.com/gsi/client', 'googleConnectSdk', callbackWithInit, attributes);
      });
    }
  }, {
    key: "_initializeGoogleAccount",
    value: function _initializeGoogleAccount(googleClientId, callback) {
      // Initialize their Google account for use
      google.accounts.id.initialize({
        client_id: googleClientId,
        callback: callback
      });
    }
  }, {
    key: "_promptGoogleAccount",
    value: function _promptGoogleAccount(googleClientId) {
      var _this = this; // Display the login prompt, deal with any errors


      google.accounts.id.prompt(function (notification) {
        if (notification.isNotDisplayed()) {
          var failedReason = notification.getNotDisplayedReason(); // If they are in the One Tap cooldown window, reset things and show the prompt again

          if (failedReason == 'suppressed_by_user') {
            document.cookie = "g_state=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT";
            google.accounts.id.prompt();
          } else if (failedReason == 'opt_out_or_no_session') {
            // They are not logged in to their browser, so display the account chooser, here is the callback handler
            var accountChooserCallback = function accountChooserCallback() {
              google.accounts.id.prompt();
            }; // Make the actual call


            _this._getGoogleAccountInfo(googleClientId, '', accountChooserCallback);
          } else {
            // Some other error happened, log it
            console.error('Error logging in via Google SDK: ' + failedReason);
          }
        }
      });
    }
  }, {
    key: "_getGoogleAccountInfo",
    value: function _getGoogleAccountInfo(googleClientId, userEmail, callback) {
      // Prepare the token client
      var client = google.accounts.oauth2.initTokenClient({
        client_id: googleClientId,
        scope: 'https://www.googleapis.com/auth/userinfo.profile',
        hint: userEmail,
        prompt: '',
        callback: callback
      }); // Make the request to obtain the user's access token

      client.requestAccessToken();
    }
  }]);

  return GoogleConnectSdk;
}();